/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFactoringService.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/factoring-service";

export class AutogenModelFactoringService<RowType extends ModelRow> extends Endpoint<RowType, RowFactoringServiceFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFactoringService extends ModelRow<RowFactoringServiceFields> {
	constructor(values?: Partial<RowFactoringServiceFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFactoringServiceFields {
	bill_type: string;
	company_id: string;
	customer_id: string;
	descr: string;
	email_address: string;
	ftp_password: string;
	ftp_port: number;
	ftp_url: string;
	ftp_username: string;
	http_password: string;
	http_server: string;
	http_username: string;
	id: string;
}

